import React, { useState } from "react";
import {
  FaUserTie,
  FaBus,
  FaHeadset,
  FaUsers,
  FaLaptopCode,
} from "react-icons/fa";
import "./Career.css";

// const openings = [
//   {
//     title: "Driver",
//     icon: <FaBus />,
//     desc: "Experienced commercial drivers with valid license, route knowledge and customer-friendly attitude.",
//   },
//   {
//     title: "Operations Staff",
//     icon: <FaUsers />,
//     desc: "Handle daily fleet operations, trip coordination, vehicle scheduling and ground support.",
//   },
//   {
//     title: "Customer Support",
//     icon: <FaHeadset />,
//     desc: "Manage booking inquiries, client coordination and service support via calls and WhatsApp.",
//   },
//   {
//     title: "Partners",
//     icon: <FaUserTie />,
//     desc: "Fleet owners and travel partners looking to grow business with Urbania rental services.",
//   },
//   {
//     title: "Digital Associates",
//     icon: <FaLaptopCode />,
//     desc: "Support digital marketing, content updates, lead management and online growth initiatives.",
//   },
// ];


const openings = [
  {
    title: "Driver",
    img: "/images/career/1.jpeg",
    desc: "Experienced commercial drivers with valid license, route knowledge and customer-friendly attitude.",
  },
  {
    title: "Operations Staff",
    img: "/images/career/2.jpeg",
    desc: "Handle daily fleet operations, trip coordination, vehicle scheduling and ground support.",
  },
  {
    title: "Customer Support",
    img: "/images/career/3.jpeg",
    desc: "Manage booking inquiries, client coordination and service support via calls and WhatsApp.",
  },
  {
    title: "Partners",
    img: "/images/career/4.jpeg",
    desc: "Fleet owners and travel partners looking to grow business with Urbania rental services.",
  },
  {
    title: "Digital Associates",
    img: "/images/career/5.jpeg",
    desc: "Support digital marketing, content updates, lead management and online growth initiatives.",
  },
];

const Career = () => {
  const [form, setForm] = useState({
    name: "",
    phone: "",
    email: "",
    position: "",
    message: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const whatsappNumber = "917620411277";

    const text = `
*Career Application – Aaryan Travels*

👤 Name: ${form.name}
📞 Mobile: ${form.phone}
📧 Email: ${form.email}
💼 Position: ${form.position}

📝 Message:
${form.message}
`;

    window.open(
      `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(text)}`,
      "_blank"
    );
  };

  return (
   <>
   <div
      className="breadcumb-wrapper"
      
      data-overlay="black"
      data-opacity="3"
    >
      <div className="container">
        <div className="breadcumb-content text-center">
          <h1 className="breadcumb-title">Career</h1>
        </div>
      </div>
    </div>
   
    <section className="career-section">
      <div className="container">

        

        {/* OPENINGS */}
        <div className="row career-openings">
          {openings.map((job, index) => (
            <div className="col-12 col-md-4 mb-4" key={index}>
              <div className="career-card">
                {/* <div className="career-icon">{job.icon}</div> */}
                <div className="career-">
  <img src={job.img} alt={job.title} />
</div>
                <h4 className="text-center darkcolorrr"> {job.title}</h4>
                <p >{job.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* FORM */}
        <div className="career-form-wrap">
          <h3 className="text-center">Apply Now</h3>

          <form className="career-form" onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-12 col-md-6">
                <input
                  type="text"
                  name="name"
                  placeholder="Full Name"
                  required
                  onChange={handleChange}
                />
              </div>

              <div className="col-12 col-md-6">
                <input
                  type="tel"
                  name="phone"
                  placeholder="Mobile Number"
                  required
                  maxLength="10"
                  onChange={handleChange}
                />
              </div>

              <div className="col-12 col-md-6">
                <input
                  type="email"
                  name="email"
                  placeholder="Email Address"
                  required
                  onChange={handleChange}
                />
              </div>

              <div className="col-12 col-md-6">
                <select
                  name="position"
                  required
                  onChange={handleChange}
                >
                  <option value="">Select Position</option>
                  <option>Driver</option>
                  <option>Operations Staff</option>
                  <option>Customer Support</option>
                  <option>Partner</option>
                  <option>Digital Associate</option>
                </select>
              </div>

              <div className="col-12">
                <textarea
                  name="message"
                  placeholder="Experience / Additional Details"
                  onChange={handleChange}
                ></textarea>
              </div>

              <div className="col-12 text-center">
                <button type="submit">
                  Send Application on WhatsApp
                </button>
              </div>
            </div>
          </form>
        </div>

      </div>
    </section>
   </>
  );
};

export default Career;
